
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import RadioButton from '@/components/radio-button.vue'
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import PickerInterval from '@/components/picker-interval.vue';
	import {
		grade
	} from '@/utils/config';
	import {
		GetAgentEarningsList
	} from '@/api/statistic'
	import {
		getSearchDate,
		nextDay
	}from "@/utils/index"

	@Component({
		name: 'member-performance',
		components: {
			RadioButton,
			PageFooter,
			PickerDate,
			PickerInterval
		}
	})
	export default class MemberPerformance extends Vue {
		private loading = false;
		private list: any = []
		private memberKey = ''
		private upmemberKey = ''
		private phoneKey = ''
		private filterTime: any = ''
		private radioType = null;
		private radioList: any = [{
				label: '全部',
				value: null
			}, {
				label: '联创',
				value: 1
			}, {
				label: '核心',
				value: 2
			}, {
				label: '总代',
				value: 3
			}
		];
		private selectTime = 0
		private selectTimes = [{
			label: '下单时间',
			value: 0
		}];
		private gradeList = grade;
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private personal = []
		private team = []

		private mounted() {
			this.initTime()
			this.getList()
		}

		private initTime(){
			this.filterTime = [getSearchDate(2,false,-6)[0],getSearchDate(2)[0]].join('/')
		}


		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.memberKey = '';
			this.upmemberKey = '';
			this.phoneKey = '';
			this.pageNo = 1;
			this.personal = ['','']
			this.team = ['','']
			// this.filterTime = getSearchDate(1).join('/')
			this.initTime()
			this.getList();
		}
		private testinterval(){
			let list = [...this.personal,...this.team]
			let two = /^\d+(\.\d{1,2})?$/
			for(let index in list){
				// console.log(index)
				if(list[index]&&!two.test(list[index])){
					this.$message.error('请输入数字，最多两位小数')
					return false
				}
				let num:any = index+1
				if(num%2==0&&list[index]>999999.99){
					this.$message.error('金额最大为999999.99')
					return false
				}
			}
			return true
		}
		private async getList() {
			if(!this.testinterval()) return
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				RoleGrade: this.radioType,
				Name: this.memberKey,
				Phone: this.phoneKey,
				SuperName: this.upmemberKey,
				MinPersonalPerformance:this.personal[0]||'',
				MaxPersonalPerformance:this.personal[1]||'',
				MinTeamPerformance:this.team[0]||'',
				MaxTeamPerformance:this.team[1]||'',
			}

			if (this.filterTime){
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = nextDay(dt[1],1)
			}

			this.loading = true;

			try {
				const res: any = await GetAgentEarningsList(params);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				// console.log(e);
			} finally{
				this.loading = false;
			}
		}

		/**
		 * 跳转到详情
		 */
		private toDetail(record: any) {

			let query:any = {
				id: record.MemberId,
				roleGrade: record.RoleGrade,
				superId: record.SuperId,
			}

			if (this.filterTime){
				var dt = this.filterTime.split('/');
				query.startTime = encodeURIComponent(dt[0]);
				query.endTime = encodeURIComponent(nextDay(dt[1],1));
			}

			this.$router.push({
				name: 'Member_Performance_Desc',
				query: query
			})
		}
	}
